
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46all_93y9rYtCFFWgMeta } from "/Users/james/www/ecomm/apps/front2/pages/[...all].vue?macro=true";
import { default as aboutqz0esASGVoMeta } from "/Users/james/www/ecomm/apps/front2/pages/about.vue?macro=true";
import { default as aboutUsmnpG65iO71Meta } from "/Users/james/www/ecomm/apps/front2/pages/aboutUs.vue?macro=true";
import { default as indexUqppZpsg03Meta } from "/Users/james/www/ecomm/apps/front2/pages/account/addresses/[id]/index.vue?macro=true";
import { default as indexzTj0IfKhJZMeta } from "/Users/james/www/ecomm/apps/front2/pages/account/addresses/index.vue?macro=true";
import { default as indexH1Yj3YHCglMeta } from "/Users/james/www/ecomm/apps/front2/pages/account/alerts/index.vue?macro=true";
import { default as indexm5nWaYNWQBMeta } from "/Users/james/www/ecomm/apps/front2/pages/account/cashbackWallets/index.vue?macro=true";
import { default as indexe8PeZPvnFGMeta } from "/Users/james/www/ecomm/apps/front2/pages/account/cashWallets/index.vue?macro=true";
import { default as indexZO3S3dEAaDMeta } from "/Users/james/www/ecomm/apps/front2/pages/account/claimVouchers/index.vue?macro=true";
import { default as indexggss1ADphpMeta } from "/Users/james/www/ecomm/apps/front2/pages/account/commWallets/index.vue?macro=true";
import { default as index02NykAshuTMeta } from "/Users/james/www/ecomm/apps/front2/pages/account/creditSlips/index.vue?macro=true";
import { default as indexbd6ED611UdMeta } from "/Users/james/www/ecomm/apps/front2/pages/account/favoriteProducts/index.vue?macro=true";
import { default as index_46clientKh4lar6WvYMeta } from "/Users/james/www/ecomm/apps/front2/pages/account/index.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/Users/james/www/ecomm/apps/front2/node_modules/.pnpm/nuxt@3.15.4_@types+node@22.14.0_eslint@9.23.0_less@4.2.2_sass@1.86.2_typescript@5.8.2_vite@6.2.5/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as indexkvb91oXKIoMeta } from "/Users/james/www/ecomm/apps/front2/pages/account/loyaltyPoints/index.vue?macro=true";
import { default as indexDY7q0OKixyMeta } from "/Users/james/www/ecomm/apps/front2/pages/account/merchandiseReturns/index.vue?macro=true";
import { default as indexGSstVMZP7bMeta } from "/Users/james/www/ecomm/apps/front2/pages/account/orderHistories/[channelOrderId]/index.vue?macro=true";
import { default as index32wQ89YofNMeta } from "/Users/james/www/ecomm/apps/front2/pages/account/orderHistories/[channelOrderId]/invoice/[invoiceId]/index.vue?macro=true";
import { default as index7S52xldgNYMeta } from "/Users/james/www/ecomm/apps/front2/pages/account/orderHistories/index.vue?macro=true";
import { default as indexstkFZxq2BqMeta } from "/Users/james/www/ecomm/apps/front2/pages/account/personalInformation/index.vue?macro=true";
import { default as indexzPLoUvRk3sMeta } from "/Users/james/www/ecomm/apps/front2/pages/account/profile/index.vue?macro=true";
import { default as indexrryKnF0LOeMeta } from "/Users/james/www/ecomm/apps/front2/pages/account/salesReports/[orderreport_id]/index.vue?macro=true";
import { default as index2yJCk1MW1dzMeta } from "/Users/james/www/ecomm/apps/front2/pages/account/salesReports/[orderreport_id]/index2.vue?macro=true";
import { default as indexYbzSBG1B9EMeta } from "/Users/james/www/ecomm/apps/front2/pages/account/salesReports/index.vue?macro=true";
import { default as indexJC9TVTJ9FEMeta } from "/Users/james/www/ecomm/apps/front2/pages/account/vouchers/index.vue?macro=true";
import { default as index8CRq4cmuHCMeta } from "/Users/james/www/ecomm/apps/front2/pages/b/outlet/index.vue?macro=true";
import { default as indexiounCbt9NgMeta } from "/Users/james/www/ecomm/apps/front2/pages/c/[id]/[id2]/[id3]/[id4]/index.vue?macro=true";
import { default as indexQjrNEtQl0TMeta } from "/Users/james/www/ecomm/apps/front2/pages/c/[id]/[id2]/[id3]/index.vue?macro=true";
import { default as indexNRZ66dniA5Meta } from "/Users/james/www/ecomm/apps/front2/pages/c/[id]/[id2]/index.vue?macro=true";
import { default as indexvNluqElgORMeta } from "/Users/james/www/ecomm/apps/front2/pages/c/[id]/index.vue?macro=true";
import { default as indexS3VCvUI2aZMeta } from "/Users/james/www/ecomm/apps/front2/pages/c/ce/index.vue?macro=true";
import { default as indexsuD8jkpq6ZMeta } from "/Users/james/www/ecomm/apps/front2/pages/c/iluvmyface/index.vue?macro=true";
import { default as indexs1gLSy9BhtMeta } from "/Users/james/www/ecomm/apps/front2/pages/c/sales/index.vue?macro=true";
import { default as index5UMQ3mGFDdMeta } from "/Users/james/www/ecomm/apps/front2/pages/c/skincare/index.vue?macro=true";
import { default as indexw1OzUOn7DUMeta } from "/Users/james/www/ecomm/apps/front2/pages/c/skinTherapies/index.vue?macro=true";
import { default as indexTEKFw7X2nwMeta } from "/Users/james/www/ecomm/apps/front2/pages/c/spaWellness/index.vue?macro=true";
import { default as indexk8MgjIAw9lMeta } from "/Users/james/www/ecomm/apps/front2/pages/c/therapies/index.vue?macro=true";
import { default as index_46clientBz1xZ4H6hQMeta } from "/Users/james/www/ecomm/apps/front2/pages/cart/index.client.vue?macro=true";
import { default as cataloguebz2GeYf11yMeta } from "/Users/james/www/ecomm/apps/front2/pages/catalogue.vue?macro=true";
import { default as index_46client4PmmJQFkLfMeta } from "/Users/james/www/ecomm/apps/front2/pages/checkout/index.client.vue?macro=true";
import { default as paymentBbhndfrWxzMeta } from "/Users/james/www/ecomm/apps/front2/pages/checkout/payment.vue?macro=true";
import { default as successs5IqrGIBghMeta } from "/Users/james/www/ecomm/apps/front2/pages/checkout/success.vue?macro=true";
import { default as contactUJ6ABzWrFxMeta } from "/Users/james/www/ecomm/apps/front2/pages/contact.vue?macro=true";
import { default as deliveryPolicy6jah3s7Mn6Meta } from "/Users/james/www/ecomm/apps/front2/pages/deliveryPolicy.vue?macro=true";
import { default as deliveryPriceLWzEiYK7JsMeta } from "/Users/james/www/ecomm/apps/front2/pages/deliveryPrice.vue?macro=true";
import { default as faqPTGjPg48uYMeta } from "/Users/james/www/ecomm/apps/front2/pages/faq.vue?macro=true";
import { default as index1ifkBdAh0eMeta } from "/Users/james/www/ecomm/apps/front2/pages/favorites/index.vue?macro=true";
import { default as howtobuygnbM3urD36Meta } from "/Users/james/www/ecomm/apps/front2/pages/howtobuy.vue?macro=true";
import { default as indexAhfGxbsjqxMeta } from "/Users/james/www/ecomm/apps/front2/pages/index.vue?macro=true";
import { default as index4OEZQP34CNMeta } from "/Users/james/www/ecomm/apps/front2/pages/login/index.vue?macro=true";
import { default as reset_45dove22AXrK8hMeta } from "/Users/james/www/ecomm/apps/front2/pages/login/reset-do.vue?macro=true";
import { default as resetU2gaC5cgovMeta } from "/Users/james/www/ecomm/apps/front2/pages/login/reset.vue?macro=true";
import { default as logouto6SsxIO5p9Meta } from "/Users/james/www/ecomm/apps/front2/pages/logout.vue?macro=true";
import { default as _202406_45shipmentUKAkSdNPLpMeta } from "/Users/james/www/ecomm/apps/front2/pages/news/202406-shipment.vue?macro=true";
import { default as cancelH5rTGm3kLdMeta } from "/Users/james/www/ecomm/apps/front2/pages/payment/cancel.vue?macro=true";
import { default as successu1CgG1p6ZbMeta } from "/Users/james/www/ecomm/apps/front2/pages/payment/success.vue?macro=true";
import { default as privacyPolicyZkE3wit6f6Meta } from "/Users/james/www/ecomm/apps/front2/pages/privacyPolicy.vue?macro=true";
import { default as _91id_93QknM5SbmgpMeta } from "/Users/james/www/ecomm/apps/front2/pages/products/[id].vue?macro=true";
import { default as indexrZicoe3zSgMeta } from "/Users/james/www/ecomm/apps/front2/pages/products/index.vue?macro=true";
import { default as indexqtsRA9SGQ2Meta } from "/Users/james/www/ecomm/apps/front2/pages/register/index.vue?macro=true";
import { default as returnPolicyd72Un7ds5EMeta } from "/Users/james/www/ecomm/apps/front2/pages/returnPolicy.vue?macro=true";
import { default as salesHZqJeYqqrQMeta } from "/Users/james/www/ecomm/apps/front2/pages/sales.vue?macro=true";
import { default as indexyi1a3v5qqoMeta } from "/Users/james/www/ecomm/apps/front2/pages/search/index.vue?macro=true";
import { default as termsOfUseV4H4zomikHMeta } from "/Users/james/www/ecomm/apps/front2/pages/termsOfUse.vue?macro=true";
import { default as tipsAdviceoDskxtsUKVMeta } from "/Users/james/www/ecomm/apps/front2/pages/tipsAdvice.vue?macro=true";
import { default as whyusaD9c4njHTPMeta } from "/Users/james/www/ecomm/apps/front2/pages/whyus.vue?macro=true";
export default [
  {
    name: "all",
    path: "/:all(.*)*",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/[...all].vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/about.vue")
  },
  {
    name: "aboutUs",
    path: "/aboutUs",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/aboutUs.vue")
  },
  {
    name: "account-addresses-id",
    path: "/account/addresses/:id()",
    meta: indexUqppZpsg03Meta || {},
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/account/addresses/[id]/index.vue")
  },
  {
    name: "account-addresses",
    path: "/account/addresses",
    meta: indexzTj0IfKhJZMeta || {},
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/account/addresses/index.vue")
  },
  {
    name: "account-alerts",
    path: "/account/alerts",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/account/alerts/index.vue")
  },
  {
    name: "account-cashbackWallets",
    path: "/account/cashbackWallets",
    meta: indexm5nWaYNWQBMeta || {},
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/account/cashbackWallets/index.vue")
  },
  {
    name: "account-cashWallets",
    path: "/account/cashWallets",
    meta: indexe8PeZPvnFGMeta || {},
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/account/cashWallets/index.vue")
  },
  {
    name: "account-claimVouchers",
    path: "/account/claimVouchers",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/account/claimVouchers/index.vue")
  },
  {
    name: "account-commWallets",
    path: "/account/commWallets",
    meta: indexggss1ADphpMeta || {},
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/account/commWallets/index.vue")
  },
  {
    name: "account-creditSlips",
    path: "/account/creditSlips",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/account/creditSlips/index.vue")
  },
  {
    name: "account-favoriteProducts",
    path: "/account/favoriteProducts",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/account/favoriteProducts/index.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: index_46clientKh4lar6WvYMeta || {},
    component: () => createClientPage(() => import("/Users/james/www/ecomm/apps/front2/pages/account/index.client.vue"))
  },
  {
    name: "account-loyaltyPoints",
    path: "/account/loyaltyPoints",
    meta: indexkvb91oXKIoMeta || {},
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/account/loyaltyPoints/index.vue")
  },
  {
    name: "account-merchandiseReturns",
    path: "/account/merchandiseReturns",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/account/merchandiseReturns/index.vue")
  },
  {
    name: "account-orderHistories-channelOrderId",
    path: "/account/orderHistories/:channelOrderId()",
    meta: indexGSstVMZP7bMeta || {},
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/account/orderHistories/[channelOrderId]/index.vue")
  },
  {
    name: "account-orderHistories-channelOrderId-invoice-invoiceId",
    path: "/account/orderHistories/:channelOrderId()/invoice/:invoiceId()",
    meta: index32wQ89YofNMeta || {},
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/account/orderHistories/[channelOrderId]/invoice/[invoiceId]/index.vue")
  },
  {
    name: "account-orderHistories",
    path: "/account/orderHistories",
    meta: index7S52xldgNYMeta || {},
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/account/orderHistories/index.vue")
  },
  {
    name: "account-personalInformation",
    path: "/account/personalInformation",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/account/personalInformation/index.vue")
  },
  {
    name: "account-profile",
    path: "/account/profile",
    meta: indexzPLoUvRk3sMeta || {},
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/account/profile/index.vue")
  },
  {
    name: "account-salesReports-orderreport_id",
    path: "/account/salesReports/:orderreport_id()",
    meta: indexrryKnF0LOeMeta || {},
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/account/salesReports/[orderreport_id]/index.vue")
  },
  {
    name: "account-salesReports-orderreport_id-index2",
    path: "/account/salesReports/:orderreport_id()/index2",
    meta: index2yJCk1MW1dzMeta || {},
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/account/salesReports/[orderreport_id]/index2.vue")
  },
  {
    name: "account-salesReports",
    path: "/account/salesReports",
    meta: indexYbzSBG1B9EMeta || {},
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/account/salesReports/index.vue")
  },
  {
    name: "account-vouchers",
    path: "/account/vouchers",
    meta: indexJC9TVTJ9FEMeta || {},
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/account/vouchers/index.vue")
  },
  {
    name: "b-outlet",
    path: "/b/outlet",
    meta: index8CRq4cmuHCMeta || {},
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/b/outlet/index.vue")
  },
  {
    name: "c-id-id2-id3-id4",
    path: "/c/:id()/:id2()/:id3()/:id4()",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/c/[id]/[id2]/[id3]/[id4]/index.vue")
  },
  {
    name: "c-id-id2-id3",
    path: "/c/:id()/:id2()/:id3()",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/c/[id]/[id2]/[id3]/index.vue")
  },
  {
    name: "c-id-id2",
    path: "/c/:id()/:id2()",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/c/[id]/[id2]/index.vue")
  },
  {
    name: "c-id",
    path: "/c/:id()",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/c/[id]/index.vue")
  },
  {
    name: "c-ce",
    path: "/c/ce",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/c/ce/index.vue")
  },
  {
    name: "c-iluvmyface",
    path: "/c/iluvmyface",
    meta: indexsuD8jkpq6ZMeta || {},
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/c/iluvmyface/index.vue")
  },
  {
    name: "c-sales",
    path: "/c/sales",
    meta: indexs1gLSy9BhtMeta || {},
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/c/sales/index.vue")
  },
  {
    name: "c-skincare",
    path: "/c/skincare",
    meta: index5UMQ3mGFDdMeta || {},
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/c/skincare/index.vue")
  },
  {
    name: "c-skinTherapies",
    path: "/c/skinTherapies",
    meta: indexw1OzUOn7DUMeta || {},
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/c/skinTherapies/index.vue")
  },
  {
    name: "c-spaWellness",
    path: "/c/spaWellness",
    meta: indexTEKFw7X2nwMeta || {},
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/c/spaWellness/index.vue")
  },
  {
    name: "c-therapies",
    path: "/c/therapies",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/c/therapies/index.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => createClientPage(() => import("/Users/james/www/ecomm/apps/front2/pages/cart/index.client.vue"))
  },
  {
    name: "catalogue",
    path: "/catalogue",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/catalogue.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: index_46client4PmmJQFkLfMeta || {},
    component: () => createClientPage(() => import("/Users/james/www/ecomm/apps/front2/pages/checkout/index.client.vue"))
  },
  {
    name: "checkout-payment",
    path: "/checkout/payment",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/checkout/payment.vue")
  },
  {
    name: "checkout-success",
    path: "/checkout/success",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/checkout/success.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/contact.vue")
  },
  {
    name: "deliveryPolicy",
    path: "/deliveryPolicy",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/deliveryPolicy.vue")
  },
  {
    name: "deliveryPrice",
    path: "/deliveryPrice",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/deliveryPrice.vue")
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/faq.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/favorites/index.vue")
  },
  {
    name: "howtobuy",
    path: "/howtobuy",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/howtobuy.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexAhfGxbsjqxMeta || {},
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/login/index.vue")
  },
  {
    name: "login-reset-do",
    path: "/login/reset-do",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/login/reset-do.vue")
  },
  {
    name: "login-reset",
    path: "/login/reset",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/login/reset.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/logout.vue")
  },
  {
    name: "news-202406-shipment",
    path: "/news/202406-shipment",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/news/202406-shipment.vue")
  },
  {
    name: "payment-cancel",
    path: "/payment/cancel",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/payment/cancel.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/payment/success.vue")
  },
  {
    name: "privacyPolicy",
    path: "/privacyPolicy",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/privacyPolicy.vue")
  },
  {
    name: "products-id",
    path: "/products/:id()",
    meta: _91id_93QknM5SbmgpMeta || {},
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/products/[id].vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/products/index.vue")
  },
  {
    name: "register",
    path: "/register",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/register/index.vue")
  },
  {
    name: "returnPolicy",
    path: "/returnPolicy",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/returnPolicy.vue")
  },
  {
    name: "sales",
    path: "/sales",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/sales.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/search/index.vue")
  },
  {
    name: "termsOfUse",
    path: "/termsOfUse",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/termsOfUse.vue")
  },
  {
    name: "tipsAdvice",
    path: "/tipsAdvice",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/tipsAdvice.vue")
  },
  {
    name: "whyus",
    path: "/whyus",
    component: () => import("/Users/james/www/ecomm/apps/front2/pages/whyus.vue")
  }
]